import { useMutation } from '@apollo/client';
import { LOGOUT_MUTATION } from '../apis/auth/mutations';
import { logoutFromUI } from '../../routes/ProfilePages/ProfileContent/utils';

type LogoutOptions = { withoutReload?: boolean };

export const useLogout = () => {
  const [logoutMutation, { loading }] = useMutation(LOGOUT_MUTATION);

  const logout = async (options: LogoutOptions = {}) => {
    try {
      const { data } = await logoutMutation();
      if (data.logout) {
        logoutFromUI(options);
      } else {
        console.error('Logout failed');
      }
    } catch (error) {
      logoutFromUI(options);
      console.error('Error during logout:', error);
    }
  };

  return {
    logout,
    loading,
  };
};
